module.exports = __webpack_public_path__ + "static/media/logoIcon.06ceb1bc.svg";